import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, IconButton } from '@mui/material';

import { palette, spaces } from '../../../../../assets/styles/themes/tokens';
import createNonPropagatingEventHandler from '../../../../../utils/createNonPropagatingEventHandler';
import getMuiIcon from '../../../../../utils/getMuiIcon';

const MuiCardBaseShortShowLessButton: React.FC<{ toggleTruncated: () => void }> = ({ toggleTruncated }) => {
  const { t } = useTranslation();
  
  return (
    <IconButton
      aria-label={t('Show less')}
      size='medium'
      onClick={createNonPropagatingEventHandler(toggleTruncated)}
      sx={{
        position: 'absolute',
        bottom: `-${spaces.xs}`,
        right: `-${spaces.xs}`,
      }}
    >
      <Box
        component={getMuiIcon('arrowUp')}
        sx={{ color: palette.text.secondary }}
      />
    </IconButton>
  );
};

export default MuiCardBaseShortShowLessButton;
